import type { CSSProperties } from 'react';

export const sanitizeFileName = (name: string): string =>
    name
        .replace(/[/\\:*?"<>|]/g, '')
        .replace(/\s+/g, '_')
        .trim() || 'export';

/** Clamps text to `maxLines` lines. For a fixed count, Tailwind's `line-clamp-N` does the same. */
export const getTextClampedToLinesProps = (maxLines = 2): CSSProperties => ({
    display: '-webkit-box',
    WebkitLineClamp: maxLines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
});
